// Curriculum registry. Domains 01–07 are real modules. The `pending` helper is kept
// for future domains: a unit marked implemented:false is IMPLEMENTATION PENDING and
// the progression engine treats it as un-completable.

import d01 from '../domains/d01/index.js';
import d02 from '../domains/d02/index.js';
import d03 from '../domains/d03/index.js';
import d04 from '../domains/d04/index.js';
import d05 from '../domains/d05/index.js';
import d06 from '../domains/d06/index.js';
import d07 from '../domains/d07/index.js';

const pending = (id, title, type) => ({ id, title, type, implemented: false });
const planned = (titles) => titles.map(([t, type], i) => pending(`u${String(i + 1).padStart(2, '0')}`, t, type));

export const curriculum = {
  domains: [
    d01,
    d02,
    d03,
    d04,
    d05,
    d06,
    d07,
  ],
  phase2: {
    title: 'Network Security Engineering',
    tracks: ['Cisco ASA', 'FortiGate', 'Palo Alto Networks', 'Firewall policies', 'NAT', 'VPN', 'Security zones', 'High availability', 'Segmentation', 'Security monitoring', 'Security troubleshooting'],
  },
};

export const findUnit = (dId, uId) => curriculum.domains.find((d) => d.id === dId)?.units.find((u) => u.id === uId);
export const findDomain = (dId) => curriculum.domains.find((d) => d.id === dId);
